import { render, staticRenderFns } from "./Nt20.vue?vue&type=template&id=dd1d5784"
import script from "./Nt20.vue?vue&type=script&lang=js"
export * from "./Nt20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports